// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.loginCentrado {
  flex-direction: column;
  box-sizing: border-box;
  display: flex;
  place-content: stretch center;
  align-items: stretch;
}

form {
  width: 40%;
  margin: 0 auto; /* Centra el bloque horizontalmente */
}

@media (max-width: 992px) {
  form {
    width: 80%; /* Amplía el formulario para aprovechar el espacio */
  }
}
/* Pantallas pequeñas (Móviles - menos de 576px) */
@media (max-width: 576px) {
  form {
    width: 95%; /* Ocupa casi todo el ancho en móviles */
  }
  .container-login {
    padding: 1.5em !important; /* Reduce los paddings internos para ganar espacio */
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
